import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../app/store'
import { Avatar, IconButton } from '@mui/material'
import { useDispatch } from 'react-redux'
import { updateShowSideModal } from '../../user/userSlice'
import GenerateIcon from '../../../components/GenerateIcon'
import ApplicationLogo from '../../../components/ApplicationLogo'
import { updateShowMobileSidebarStatus } from '../adminPagesSlice'

export default function AdminHeader() {

    const user = useSelector((state: RootState) => state.user.details)
    const dispatch = useDispatch()

    const { smallerSideBar } = useSelector((state: RootState) => state.adminPages)

    /**
     * Show user modal
     */
    const showUserSidebarModal = () => dispatch(updateShowSideModal(true))

    return(
        <header className={smallerSideBar ? "admin-panel-header-container full-size" : "admin-panel-header-container"}>
            <div className="content-of-admin-panel-header-container">

                <div className="menu-of-admin-panel-header-container">
                    <div className="content-of-menu-of-admin-panel-header-container">

                        <div className="item-of-menu-of-admin-panel-header-container mobile-menu-header-switch">
                            <div className="content-of-item-of-menu-of-admin-panel-header-container">
                                {/* <div className="mobile-admin-header-logo">
                                    <ApplicationLogo />
                                </div> */}
                                <IconButton onClick={() => dispatch(updateShowMobileSidebarStatus(true))}>
                                    <GenerateIcon icon="menu" />
                                </IconButton>
                            </div>
                        </div>

                        <div className="item-of-menu-of-admin-panel-header-container user-box">
                            <div className="content-of-item-of-menu-of-admin-panel-header-container">
                                <Avatar onClick={() => showUserSidebarModal()} className="header-user-avatar" alt={user.first_name} src={user.thumbnail ? user.thumbnail : ""}>{user.first_name.charAt(0)}</Avatar>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </header>
    )
}